export const initialState = {
    fieldsSchema: [],
    email: '',
    validEmail: true,
    isOpen: false,
    isLoading: false,
    optionsIsReady: false,
    selected: {},
    filters: {},
    numSelected: 0,
};

export function reducer(state, action) {
    switch (action.type) {
        case 'openModal':
            return {
                ...initialState,
                isOpen: true,
                filters: action.filters,
            };
        case 'setSchema':
            return { ...state, optionsIsReady: true, ...action.data };
        case 'closeModal':
            return { ...state, isOpen: false };
        case 'setEmail':
            return { ...state, email: action.email, validEmail: true };
        case 'setInvalidEmail':
            return { ...state, validEmail: false };
        case 'setLoading':
            return { ...state, isLoading: action.value };
        case 'setSelected':
            return { ...state, selected: action.selected, numSelected: action.numSelected };
        case 'finishExport':
            return { ...state, isOpen: false, isLoading: false };
        default:
            throw new Error('No action provided');
    }
}
